import { Grid, InputAdornment, Typography } from "@mui/material";
import { getOptionLabel } from "common/enums";
import InputFieldText from "Components/Common/InputFieldText";
import PropTypes from "prop-types";
import React from "react";
import { onlyNumberKeys } from "utils";

const FPPPAChargesForm = ({ fppaChargesData, formik,isMeterReadingForm=false }) => {
  const { handleChange } = formik;
  return (
    <>
      <Grid item xs={12}>
        <Typography className="mb-4" lineHeight="1" variant="h6">
         Variable Fuel Surcharges
        </Typography>
      </Grid>
      
      {fppaChargesData?.map(({ tariffId }, index) => {
        const tariffLabel = getOptionLabel("tariff", tariffId);
        return (
          <React.Fragment key={index}>
            <Grid item xs={12} sm={4}>
              <InputFieldText
                label={`${tariffLabel} charges` + "*"}
                name={`fpppaChargesData.${index}.charges`}
                formik={formik}
                type="number"
                disabled={!!isMeterReadingForm}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">%</InputAdornment>
                  ),
                }}
                onChange={(e) => {
                  handleChange(e);
                }}
                placeholder={`Enter ${tariffLabel} Charges`}
              />
            </Grid>
          </React.Fragment>
        );
      })}
    </>
  );
};

FPPPAChargesForm.propTypes = {
  fppaChargesData: PropTypes.array,
  formik: PropTypes.object,
  isMeterReadingForm:PropTypes.bool
};

export default FPPPAChargesForm;
